<template>
    <div class="slideshow">
        <div class="crumbs">
            <el-breadcrumb separator="/">
                <el-breadcrumb-item> <i class="el-icon-picture-outline-round"></i> 公共图片列表 </el-breadcrumb-item>
            </el-breadcrumb>
        </div>
        <div class="container">
            <div class="handle-box">
                <!-- 批量删除 -->
                <el-button type="danger" icon="el-icon-delete" class="handle-del mr10" @click="delAllSelection">批量删除</el-button>
                <!-- 新增 -->
                <el-button type="primary" icon="el-icon-plus" class="handle-del mr10 right" @click="addSildeshow">{{ $t('common.add') }}</el-button>
            </div>
            <el-table
                :data="tableData"
                border
                class="table"
                ref="multipleTable"
                header-cell-class-name="table-header"
                @selection-change="handleSelectionChange"
            >
                <el-table-column type="selection" width="55" align="center"></el-table-column>
                <el-table-column label="背景图" width="150" align="center">
                    <template slot-scope="scope">
                        <el-image class="table-td-thumb" :src="scope.row.img" :preview-src-list="[scope.row.img]"></el-image>
                    </template>
                </el-table-column>
                <el-table-column label="模块名" align="center" prop="type" :show-overflow-tooltip="true"> </el-table-column>
                <el-table-column label="状态" align="center" width="150">
                    <template slot-scope="scope">
                        <el-tag :type="scope.row.status === '1' ? 'success' : scope.row.status === '2' ? 'danger' : ''">{{
                            scope.row.status == 1 ? '显示中' : '未显示'
                        }}</el-tag>
                        <el-switch
                            v-model="scope.row.status"
                            style="margin-left: 5px"
                            active-value="1"
                            inactive-value="2"
                            @change="tableDataStatus(scope)"
                        >
                        </el-switch>
                    </template>
                </el-table-column>

                <el-table-column label="操作" width="150" align="center">
                    <template slot-scope="scope">
                        <el-button type="text" icon="el-icon-edit" @click="handleEdit(scope.$index, scope.row)">{{ $t('common.edit') }}</el-button>
                        <el-button type="text" icon="el-icon-delete" class="red" @click="handleDelete(scope.$index, scope.row)"
                            >{{ $t('common.delete') }}</el-button
                        >
                    </template>
                </el-table-column>
            </el-table>
            <div class="pagination">
                <el-pagination
                    background
                    layout="total, prev, pager, next"
                    :current-page="query.page"
                    :page-size="query.page_size"
                    :total="pageTotal"
                    @current-change="handlePageChange"
                ></el-pagination>
            </div>
        </div>

        <!-- 编辑弹出框 -->
        <el-dialog :title="$t('common.edit')" :visible.sync="editVisible" width="330px">
            <el-form ref="form" :model="form" label-width="70px">
                <el-form-item label="是否显示">
                    <el-switch
                        v-model="form.status"
                        active-color="#13ce66"
                        inactive-color="#ff4949"
                        active-value="1"
                        inactive-value="2"
                        active-text="是"
                        inactive-text="否"
                    >
                    </el-switch>
                </el-form-item>
                <el-form-item label="背景图">
                    <imgUpload :onSuccess="handleAvatarSuccess" :imageUrl="editImageUrl" :data="uploadImgData" />
                </el-form-item>
                <el-form-item label="系统">
                    <el-select v-model="form.type" placeholder="请选择">
                        <el-option v-for="item in this.options.type" :key="item" :label="item" :value="item"> </el-option>
                    </el-select>
                </el-form-item>
            </el-form>
            <span slot="footer" class="dialog-footer">
                <el-button @click="editVisible = false">取 消</el-button>
                <el-button type="primary" @click="saveEdit((DialogtypeJudge = DialogtypeJudge))">确 定</el-button>
            </span>
        </el-dialog>
    </div>
</template>

<script>
import imgUpload from '@/components/component/imgUpload';
// 请求
import {
    apiNoticeImg_list,
    apiNoticeImg_add,
    apiNoticeImg_del,
    apiNoticeImg_edit,
    apiNoticeImg_pull,
    apiCurrentPermisson
} from '@/request/api';
export default {
    name: 'basetable',
    components: { imgUpload },
    data() {
        return {
            query: {
                keyword: '',
                page: 1,
                page_size: 10
            },
            perData: [],
            multipleSelection: [],
            delList: [],
            editVisible: false,
            pageTotal: 0,
            idx: -1,
            id: -1,
            fileList: [],
            dialogVisible: false,

            // 上传图片时的附加数据
            uploadImgData: {
                token: sessionStorage.getItem('userToken'),
                url: 'slideshow'
            },

            // 轮播图下拉
            options: [],

            // 主页显示列表数据
            tableData: [],

            // 编辑的预览图
            editImageUrl: '',
            // 编辑的表单数据
            form: {},

            // 新增的预览图
            imageUrl: '',
            // 新增的表单数据
            addForm: {
                status: 1,
                url: ''
            },

            // 判断处理类型
            DialogtypeJudge: ''
        };
    },
    mounted() {
        this.getData();
        this.getPull();
    },
    activated() {
        this.getData();
        this.getPermission();
    },
    methods: {
        // 获取数据
        getData() {
            apiNoticeImg_list(this.query).then(res => {
                this.tableData = res.data.data;
                this.pageTotal = res.data.count || 0;
            });
        },
        getPull() {
            apiNoticeImg_pull({}).then(res => {
                this.options = res.data;
            });
        },
        //获得页面按钮的权限（添加，修改，删除）
        getPermission() {
            apiCurrentPermisson({
                id: '53'
            }).then(res => {
                if (res.code == 2000) {
                    this.perData = res.data;
                } else {
                    this.$message.error(res.msg);
                }
            });
        },
        handleAvatarSuccess(res, file) {
            this.editImageUrl = URL.createObjectURL(file.raw);
            this.form.img_url = res.data.img;
            this.form.img = res.data.img;
        },
        // 修改图片状态
        tableDataStatus({ row }) {
            apiNoticeImg_edit(row).then(res => {});
        },
        // 删除操作
        handleDelete(index, row) {
            // 二次确认删除
            this.$confirm('确定要删除吗？', '提示', {
                type: 'warning'
            }).then(() => {
                this.$message.success('删除成功');
                apiNoticeImg_del({ id: row.id }).then(res => {});
                this.getData();
            });
        },

        // 多选操作
        handleSelectionChange(val) {
            this.multipleSelection = val;
        },
        // 批量删除
        delAllSelection() {
            const length = this.multipleSelection.length;
            this.delList = this.delList.concat(this.multipleSelection);
            var arr = [];
            for (let i = 0; i < length; i++) {
                arr.push(this.multipleSelection[i].id);
            }
            arr = arr.join(',');
            // 删除数据库
            apiNoticeImg_del({ id: arr }).then(res => {
                this.getData();
                if (res.data.code == 2000) {
                    this.$message({
                        type: 'success',
                        message: `批量删除成功`
                    });
                } else {
                    this.$message.error(res.data.data.info);
                }
                this.multipleSelection = [];
            });
        },

        // 编辑按钮
        handleEdit(index, row) {
            this.idx = index;
            this.editVisible = true;
            this.editImageUrl = row.img_url;
            this.DialogtypeJudge = 'edit';
            this.form = this.$deepClone(row);
        },
        // 新增按钮
        addSildeshow() {
            this.form = {};
            this.editImageUrl = '';
            this.DialogtypeJudge = 'add';
            this.editVisible = true;
        },
        // 保存 操作
        saveEdit(type) {
            delete this.form.img_url;
            if (!this.form.name) this.form.name = '登录背景';
            if (type == 'edit') {
                apiNoticeImg_edit(this.form).then(res => {
                    if (res.code == 4000) {
                        this.$message.error(res.data.data.error + ' ' + res.data.data.info);
                        return;
                    }
                    this.getData();
                });
            } else if (type == 'add') {
                apiNoticeImg_add(this.form).then(res => {
                    if (res.code == 2000) {
                        this.$message({
                            message: '添加成功',
                            type: 'success'
                        });
                    } else {
                        this.$message.error({
                            message: '失败'
                        });
                    }
                    this.getData();
                });
            }
            this.editVisible = false;
        },

        // 分页导航
        handlePageChange(val) {
            this.$set(this.query, 'page', val);
            this.getData();
        }
    }
};
</script>

<style lang="scss">
.el-upload--text {
    width: 178px !important;
}
.avatar-uploader .el-upload {
    border: 1px dashed #d9d9d9;
    border-radius: 6px;
    cursor: pointer;
    position: relative;
    overflow: hidden;
}
.avatar-uploader .el-upload:hover {
    border-color: #409eff;
}
.avatar-uploader-icon {
    font-size: 28px;
    color: #8c939d;
    width: 178px;
    height: 178px;
    line-height: 178px;
    text-align: center;
}
.avatar {
    width: 178px;
    height: 178px;
    display: block;
}

.right {
    float: right;
}

.handle-box {
    margin-bottom: 20px;
}

.handle-select {
    width: 120px;
}

.handle-input {
    width: 300px;
    display: inline-block;
}
.table {
    width: 100%;
    font-size: 14px;
}
.red {
    color: #ff0000;
}
.mr10 {
    margin-right: 10px;
}
.table-td-thumb {
    display: block;
    margin: auto;
    width: 40px;
    height: 40px;
}
</style>
